export const LOAD_START_MARK_KEY = 'CUSTOM_FIELD_CONTEXT_DELETE_MODAL_LOAD_START_MARK_KEY';

export const DELETE_FIELD_MODAL_CANCEL_BUTTON =
	'custom-field-context-delete-modal.ui.actions.cancel-button-wrapper';

export const DELETE_FIELD_MODAL_DELETE_BUTTON =
	'custom-field-context-delete-modal.ui.actions.delete-button-wrapper';
